import React from "react";
import AppBar from "./appBar";
import Footer from "./footer";
import notFound from '../images/not-found.png'

function Erorr() {
  return (
    <div className="flex flex-col justify-between  overflow-x-hidden">
      <AppBar />
      <div className="flex flex-col min-h-[80vh] items-center justify-center">
        <div className="font-bold mx-auto">
          <img src={notFound} />
        </div>
        <div className="h-6"></div>
        <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
          عذراً لا توجد هذه الصفحة{" "}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Erorr;
